import { FC } from "react";
import { isIneligibleLawFirm } from "../../eligibility/participantEligibilityRules";
import { IneligibleLawFirmNotice } from "./IneligibleLawFirmNotice";
import { LawyerOrLawFirmSelectField } from "./LawyerOrLawFirmSelectField";
import { LeavesOtherOnEntryField } from "./LeavesOtherOnEntryField";
import { OwnerAndVoteShareFields } from "./OwnerAndVoteShareFields";
import { PartnerExamEligibilityFields } from "./PartnerExamEligibilityFields";
import { TextFormField } from "@/features/selskabsblanketten/components/formFields/FormFields";
import { JaNej } from "../../model/registrationEnums";

type AdvokatselskabShareholderEligibilityFieldsProps = {
  namePrefix: string;
  idPrefix: string;
  isLawyerOrLawFirm: string;
  passedPartnerExam: string;
  leavesOtherOnEntry: string;
};

export const AdvokatselskabShareholderEligibilityFields: FC<
  AdvokatselskabShareholderEligibilityFieldsProps
> = ({
  namePrefix,
  idPrefix,
  isLawyerOrLawFirm,
  passedPartnerExam,
  leavesOtherOnEntry,
}) => (
  <div className="d-flex flex-column gap-4">
    <LawyerOrLawFirmSelectField
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      label="Er deltageren advokat eller et advokatselskab?"
    />
    {isIneligibleLawFirm(isLawyerOrLawFirm) && (
      <IneligibleLawFirmNotice title="Denne deltager kan ikke tilføjes" />
    )}
    <PartnerExamEligibilityFields
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      isLawyerOrLawFirm={isLawyerOrLawFirm}
      passedPartnerExam={passedPartnerExam}
      label="Har vedkommende bestået eller tilmeldt sig partnerprøven?"
      ineligibleTitle="Denne deltager kan ikke tilføjes"
    />
    <OwnerAndVoteShareFields
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      isLawyerOrLawFirm={isLawyerOrLawFirm}
      passedPartnerExam={passedPartnerExam}
      ownerShareHelperRole="deltager"
    />
    <LeavesOtherOnEntryField
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      isLawyerOrLawFirm={isLawyerOrLawFirm}
      passedPartnerExam={passedPartnerExam}
      leavesOtherOnEntry={leavesOtherOnEntry}
      label="Ophører selskabsdeltagerens tilknytning til en anden virksomhed samtidigt med indtræden i dette selskab?"
      helperWhenJa='Udtræder selskabsdeltageren af en anden ejerkreds, skal pågældende selskab indsende en blanket vedrørende ændringen. Hvis en anden advokatvirksomhed ophører med at drive advokatvirksomhed samtidigt med denne ændring, skal den pågældende virksomhed enten (1) registreres som ophørt i CVR-registret, eller også (2) skal navnet på virksomheden ændres, så "advokat" ikke længere fremgår, ligesom et eventuelt formål ikke længere skal være "at drive advokatvirksomhed / at eje aktier/anparter i en advokatvirksomhed", jf. retsplejelovens §§ 120, 124, stk. 2 og 124 a samt advokatselskabsbekendtgørelsen § 20.'
    />
    {leavesOtherOnEntry === JaNej.Ja && (
      <>
        <TextFormField
          name={`${namePrefix}.otherCompanyName`}
          label="Navn på virksomhed"
          id={`${idPrefix}-other-company-name`}
        />
        <TextFormField
          name={`${namePrefix}.otherCompanyCvr`}
          label="CVR-nr."
          id={`${idPrefix}-other-company-cvr`}
        />
      </>
    )}
  </div>
);
